<template>
  <div class="auth-wrapper" :class="{'sidebar-open' : sidebarIsOpen}">
    <ex-header/>
    <ex-sidebar/>
    <slot></slot>
  </div>
</template>

<script>
import exHeader from '../header/Header'
import exSidebar from '../sidebar/Sidebar'
export default {
  name: 'auth',
  components: {
    'ex-header': exHeader,
    'ex-sidebar': exSidebar
  },
  computed: {
    sidebarIsOpen () {
      return this.$store.state.sidebarModule.isOpen
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layouts/Auth.vue